export enum ProjectEmployeeTypes {
  KITCHEN = 'kitchen',
  SERVICE = 'service',
  TECHNICAL = 'technical',
}

export const employeeTypeLabels: Record<ProjectEmployeeTypes, string> = {
  [ProjectEmployeeTypes.KITCHEN]: 'Kuchnia',
  [ProjectEmployeeTypes.SERVICE]: 'Serwis',
  [ProjectEmployeeTypes.TECHNICAL]: 'Techniczny',
};

export const employeeTypeOptions = Object.values(ProjectEmployeeTypes).map((value) => ({
  value,
  label: employeeTypeLabels[value],
}));
